import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PropertyBagState } from '@core/states/property-bag/property-bag.state';
import { UserState } from '@core/states/user/user.state';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { PreCheckinCountriesNationalitiesState } from '@precheckin/states/countries-nationalities/precheckin-countries-nationalities.state';
import { PreCheckinFormCustomizationState } from '@precheckin/states/precheckin-form-customization/precheckin-form-customization.state';
import { PreCheckinSharedState } from '@precheckin/states/shared-state/precheckin-shared-state.state';
import { PreCheckinTrainingState } from '@precheckin/states/training/precheckin-training.state';
import { PreCheckinVisitState } from '@precheckin/states/visit/precheckin-visit.state';
import { PreCheckinVisitDocumentState } from '@precheckin/states/visit-document/preckeckin-visit-document.state';
import { FeatureState } from '@shared/components/feature-toggle/states/feature.state';
import { TrainingEventsState } from '@training/states/training-events/training-events.state';
import { TrainingPackageState } from '@training/states/training-package/training-package.state';
import { UserScheduleState } from '@training/states/user-schedule/user-schedule.state';
import { environment } from 'src/environments/environment';

import { AppStoreKeys } from './store-keys.module';
import { CourseWareState } from '../features/learning/components/courseware/states/courseware.state';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forRoot(
      [
        UserState,
        FeatureState,
        PropertyBagState,
        PreCheckinTrainingState,
        TrainingPackageState,
        TrainingEventsState,
        UserScheduleState,
        CourseWareState,
        PreCheckinVisitState,
        PreCheckinCountriesNationalitiesState,
        PreCheckinSharedState,
        PreCheckinVisitDocumentState,
        PreCheckinFormCustomizationState
      ],
      {
        developmentMode: !environment.production
      }
    ),
    NgxsReduxDevtoolsPluginModule.forRoot(),

    NgxsStoragePluginModule.forRoot({
      storage: StorageOption.SessionStorage,
      key: [
        AppStoreKeys.User,
        AppStoreKeys.TrainingPackage,
        AppStoreKeys.ToggleFeatures,
        AppStoreKeys.PropertyBagState,
        AppStoreKeys.CourseWareProgress
      ]
    })
  ],
  exports: [NgxsModule]
})
export class StoreModule { }
